/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import actionTypes from "../../../../store/actions";
import orderClasses from "../../orders/orders.module.css";
import reportClasses from "../reports.module.css";
import InventoryReceiveTable from "./inventoryReceiveTable";
import Breadcrumb from "../../../../component/breadcrumb";
import Paper from "@mui/material/Paper";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons";
import { Tooltip } from "@mui/material";
import { Grid } from "@mui/material";
import { formatDate, convertDateParam, convertTillDateParam} from "../../../../helper/dateFormatter";

// Manage order page class
class InventoryReceiveReport extends Component {
  // Declare property values that belongs to the component
  state = {
    inventoryList: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalInventoryCount: 0,
    sortBy: "datetimeReceived",
    sortOrder: "DESC",
    serialNumber: "",
    lotId: "",
    productId: "",
    productName: "",
    receiptId: "",
    inventoryTypeId: "",
    orderId: "",
    qohqty: "",
    atpqty: "",
    facilityId: "",
    facilityName: "",
    receivedFromDate: "",
    receivedToDate: "",
    receivedFromDateISO: "",
    receivedToDateISO: "",
    today: moment(new Date()).format("yyyy-MM-DD"),
    bread: [
      { title: "Reports", url: "/inventoryReceiptReport" },
      { title: "Inventory Receipt Report", url: "/inventoryReceiptReport" },
    ],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.getReceivedInventory();
  }

  // Fetch orders list
  getReceivedInventory = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    var jsonData = {
      serialNumber: this.state.serialNumber,
      lotId: this.state.lotId,
      productId: this.state.productId,
      productName: this.state.productName,
      receiptId: this.state.receiptId,
      orderId: this.state.orderId,
      receivedFromDate: this.state.receivedFromDate
        ? encodeURIComponent(convertDateParam(this.state.receivedFromDate))
        : "",
      receivedToDate: this.state.receivedToDate
        ? encodeURIComponent(
            convertTillDateParam(this.state.receivedToDate),
          )
        : "",
    };

    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&reportType=INVENTORY_RECEIPT&jsonData=${JSON.stringify(jsonData)}`,
      {},
      pageOptions,
    )
      .then((res) => {
        //let data = JSON.parse(res);
        this.setState({
          inventoryList: res.data.inventoryReceiveReport.inventoryItemAndDetail,
          totalInventoryCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((e) => {
        if (e.response) {
          this.props.setErrorMessage(e.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  };

  // convertDateParam(date) {
  //   return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  // }

  // convertTillDateParam(date) {
  //   return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  // }

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getReceivedInventory();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getReceivedInventory();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getReceivedInventory();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getReceivedInventory();
        },
      );
    }
  };

  // Update state data on input change
  onChange = (e) => {
    if (e.target.name === "receivedFromDate") {
      this.setState({
        receivedToDate: "",
      });
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search/Filter orders
  filterTable = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        page: 1,
        startRecord: 1,
        // customerBan: '',
        // customerName: '',
        // featureCode: '',
        // settlementId: '',
        // itemDescription: '',
      },
      () => {
        this.getReceivedInventory();
      },
    );
  };

  // Clear all search filters
  clearFilters = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        facilityId: "",
        facilityName: "",
        productId: "",
        productName: "",
        serialNumber: "",
        lotId: "",
        inventoryTypeId: "",
        orderId: "",
        qohqty: "",
        atpqty: "",
        receivedFromDate: "",
        receivedToDate: "",
        receivedFromDateISO: "",
        receivedToDateISO: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getReceivedInventory();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterTable();
    }
  };

  classes = { ...orderClasses, ...reportClasses };

  // Render order view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper">
            {/* Search filters start */}
            <div
              className={this.classes.searchOuterDiv}
              style={{ marginBottom: "5px" }}
            >
              {/* <div>
                            <Select
                            native
                            name={'facilityId'}
                            variant={'outlined'}
                            size={'small'}
                            label={t('Warehouse')}
                            value={this.state.facilityId}
                            onChange={(e) => { this.onChange(e) }}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                        >
                            <option value=""></option>
                            {this.state.warehouseList.map((opt, key) => (
                                <option key={key} value={opt.id}>{opt.name}</option>
                            ))}
                        </Select>
                        </div> */}
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_ID")}
                  value={this.state.productId}
                  name={"productId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.ordInputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_NAME")}
                  value={this.state.productName}
                  name={"productName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("RECEIPT_ID")}
                  value={this.state.receiptId}
                  name={"receiptId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ORDER_ID")}
                  value={this.state.orderId}
                  name={"orderId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("SERIAL_NO")}
                  value={this.state.serialNumber}
                  name={"serialNumber"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("LOT_ID")}
                  value={this.state.lotId}
                  name={"lotId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <TextField
                  name="receivedFromDate"
                  id="date"
                  type="date"
                  // style={{ width: '170px' }}
                  value={this.state.receivedFromDate}
                  label={t("RECEIVED_FROM")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{ max: this.state.today }}
                />
              </div>

              <div>
                <TextField
                  name="receivedToDate"
                  id="date"
                  type="date"
                  // style={{ width: '170px' }}
                  value={this.state.receivedToDate}
                  label={t("RECEIVED_TO")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{
                    min: this.state.receivedFromDate,
                    max: this.state.today,
                  }}
                />
              </div>

              {/* <div className={this.classes.searchOrderLabelOuter} style={{ paddingRight: 0 }}>
                                <div className={this.classes.searchOrderLabelInner} style={{ paddingRight: 0 }}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearFilters}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
            </div>
            {/* Search filters end */}

            {/* Order table component */}
            <InventoryReceiveTable
              list={this.state.inventoryList}
              rowsPerPage={this.state.rowsPerPage}
              totalInventoryCount={this.state.totalInventoryCount}
              page={this.state.page}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
            />
          </Paper>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(InventoryReceiveReport));
